(function () {
  function tagCards() {
    document.querySelectorAll("product-card.product-card, .product-card").forEach((card) => {
      // detects common swatch elements
      const hasSwatches =
        card.querySelector("swatches-variant-picker-component") ||
        card.querySelector(".variant-option--swatches") ||
        card.querySelector(".swatches") ||
        card.querySelector('[data-option-name*="Color"]') ||
        card.querySelector('[data-option-name*="colour"]');

      if (!hasSwatches) card.classList.add("no-swatches");
      else card.classList.remove("no-swatches");
    });
  }

  document.addEventListener("DOMContentLoaded", tagCards);

  // In case collection reloads via filters / infinite scroll
  const target = document.querySelector("#ProductGridContainer") || document.body;
  new MutationObserver(tagCards).observe(target, { childList: true, subtree: true });
})();
